<template>
  <MainTheme />
  <!--
    Atlas AI panel is mounted globally. The component itself gates rendering
    on `route.path.startsWith('/database/atlas-intel')` and on its own open
    state, so it costs zero DOM outside Atlas Intel. We mount it here (instead
    of editing SidePanel.vue, which is owned by the route surgeon) so the
    panel is a sibling of the entire app shell and can `position: fixed` to
    the right edge while the SidePanel main column shrinks via body padding.
  -->
  <AiChatPanel />
</template>

<script>
import MainTheme from './components/layout/MainTheme.vue'
import AiChatPanel from './components/ai-chat-panel/AiChatPanel.vue'

export default {
  name: 'App',
  components: {
    MainTheme,
    AiChatPanel
  },
  async mounted() {
    // Initialize any CSS transitions by adding a class to the document
    document.documentElement.classList.add('theme-transitions')
  }
}
</script>

<style>
/* Apply transitions to avoid theme flash when switching */
.theme-transitions * {
  transition:
    background-color 0.2s ease-in-out,
    color 0.2s ease-in-out,
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}
</style>
